export const STORAGE_KEY = "anackmira_demo_state_v3";
export const STORAGE_VERSION = 3;

export const emptyState = {
  version: STORAGE_VERSION,
  cart: [],
  wishlist: [],
  progress: {},
  orders: [],
  unlocks: [],
  currentOrderId: null,
};

const isId = (value) => Number.isInteger(value) && value > 0;

export const validateStoredState = (value) => {
  if (!value || typeof value !== "object") return { ...emptyState };
  const cart = Array.isArray(value.cart)
    ? value.cart
        .filter((item) => isId(item?.id) && typeof item?.version === "string")
        .map((item) => ({ id: item.id, version: item.version, quantity: 1 }))
    : [];
  const dedupedCart = cart.filter(
    (item, index) =>
      cart.findIndex(
        (other) => other.id === item.id && other.version === item.version
      ) === index
  );
  return {
    ...emptyState,
    cart: dedupedCart,
    wishlist: Array.isArray(value.wishlist)
      ? [...new Set(value.wishlist.filter(isId))]
      : [],
    progress:
      value.progress &&
      typeof value.progress === "object" &&
      !Array.isArray(value.progress)
        ? value.progress
        : {},
    orders: Array.isArray(value.orders)
      ? value.orders.filter((order) => order && typeof order.id === "string")
      : [],
    unlocks: Array.isArray(value.unlocks)
      ? [...new Set(value.unlocks.filter((item) => typeof item === "string"))]
      : [],
    currentOrderId:
      typeof value.currentOrderId === "string" ? value.currentOrderId : null,
    version: STORAGE_VERSION,
  };
};

export const loadState = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? validateStoredState(JSON.parse(raw)) : { ...emptyState };
  } catch (error) {
    console.warn("Resetting unreadable local demo data.", error);
    return { ...emptyState };
  }
};

export const saveState = (value) => {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(validateStoredState(value))
    );
  } catch (error) {
    console.warn("Could not persist local demo data.", error);
  }
};
